import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Polygon } from '@tcc/treadstone';

function FieldSummaryMap({ field }) {
  return <Polygon color="white" positions={field.boundary.coordinates} />;
}

FieldSummaryMap.propTypes = {
  field: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    field: state.field,
  };
}

export default connect(mapStateToProps)(FieldSummaryMap);
